import type { DeweySchema } from "../../../root/helpers/brandSchema.ts";
import type { User } from "../../../../common/api/decimal/methods/user.ts";
import { useBrandLoaderData } from "../../../root/rootLoader.ts";
import { useHomeContextUser } from "../../homeContext.ts";
import { isSampleSearchEligible } from "../../search/layout/useSampleSearchEligibility.ts";

/**
 * Shared function to check if the current user is eligible to see Recommendations.
 * Can be used in both hooks and loaders.
 */
export function supportsRecommendations(
  brand: DeweySchema,
  user: User
): boolean {
  const isSampleSearchEnabled = isSampleSearchEligible(brand, user);

  return (
    brand.InstructorHome.Recommendations.enabled &&
    user.instructor.hasRole &&
    (user.instructor.verified || isSampleSearchEnabled)
  );
}

/**
 * Hook to check if the current user is eligible to see Recommendations.
 */
export default function useSupportsRecommendations(): boolean {
  const brand = useBrandLoaderData();
  const user = useHomeContextUser();
  return supportsRecommendations(brand, user);
}
